export default [
  {
    path: '/configuracoes',
    name: 'configuracoes',
    component: () => import(/* webpackChunkName: "configuracoes" */ '../../views/configuracoes/Configuracoes')
  }
]
